import React, { useEffect } from "react";
import { Button, Space, Col, Row, Select } from "antd";
import { Controller, useForm } from "react-hook-form";
import styles from "./add-edit-parent.module.css";
import CustomDrawer from "../../../../../../../../common/custom-drawer/custom-drawer";
import CustomTextfield from "../../../../../../../../common/input/custom-textfield/custom-textfield";
import { createParent, updateParent } from "../../../../../../../../services/student";
import { PhoneOutlined } from "@ant-design/icons";
import CustomSelect from "../../../../../../../../common/input/custom-select/custom-select";
import { RELATIONSHIP_OPTIONS } from "../../../../../../../../constants/common";

const AddEditParent = ({ open, onClose, editParentData, studentId }) => {
  const { control, handleSubmit, reset } = useForm();

  useEffect(() => {
    if (editParentData?.id) {
      reset({
        fullName: editParentData?.full_name,
        relationship: editParentData?.parent_type,
        phoneNumber: editParentData?.phone_number,
        email: editParentData?.alt_email,
        occupation: editParentData?.occupation,
        address: editParentData?.address,
      });
    } else {
      reset({
        fullName: '',
        relationship: '',
        phoneNumber: '',
        email: '',
        occupation: '',
        address: '',
      });
    }
  }, [editParentData, reset, open]);

  const onSubmit = async (data) => {
    try {
      const formData = new FormData();

      formData.append("full_name", data?.fullName);
      formData.append("parent_type", data?.relationship);
      formData.append("phone_number", data?.phoneNumber);
      formData.append("alt_email", data?.email);
      formData.append("occupation", data?.occupation);
      formData.append("address", data?.address ?? '');

      if (editParentData?.id) {
        await updateParent(editParentData?.id, formData);
      } else {
        formData.append("student_id", studentId);
        await createParent(formData);
      }
      onClose();
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <CustomDrawer
      title={`${editParentData?.id ? 'Edit' : 'Add'} Parent`}
      open={open}
      onClose={onClose}
      className={styles.drawer}
      width="50vw"
      drawerStyles={{ body: { padding: "24px" } }}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className={styles.formSectionBox}>
          <Space direction="vertical" style={{ width: "100%" }} size="large">
            <Row gutter={[16, 16]}>
              <Col span={12}>
                <label
                  style={{
                    fontWeight: 500,
                    marginBottom: 6,
                    display: "inline-block",
                  }}
                >
                  Full Name<span style={{ color: "red" }}>*</span>
                </label>
                <Controller
                  name='fullName'
                  control={control}
                  rules={{ required: "Full name is required" }}
                  render={({
                    field: { onChange, value },
                    fieldState: { error },
                  }) => (
                    <CustomTextfield
                      labelColor="#171717"
                      showSearch
                      size="large"
                      value={value}
                      placeholder="Full Name"
                      onChange={onChange}
                      status={error ? "error" : ""}
                    />
                  )}
                />
              </Col>

              <Col span={12}>
                <label
                  style={{
                    fontWeight: 500,
                    marginBottom: 6,
                    display: "inline-block",
                  }}
                >
                  Relationship<span style={{ color: "red" }}>*</span>
                </label>
                <Controller
                  name='relationship'
                  control={control}
                  rules={{ required: "Relationship is required" }}
                  render={({
                    field: { onChange, value },
                    fieldState: { error },
                  }) => (
                    <CustomSelect
                      labelColor="#171717"
                      placeholder="--Select--"
                      size="large"
                      value={value}
                      onChange={onChange}
                      status={error ? "error" : ""}
                    >
                      {RELATIONSHIP_OPTIONS.map((item, index) => (
                        <Select.Option key={index} value={item?.value}>
                          {item?.label}
                        </Select.Option>
                      ))}
                    </CustomSelect>
                  )}
                />
              </Col>
            </Row>

            <Row gutter={[16, 16]}>
              <Col span={12}>
                <label
                  style={{
                    fontWeight: 500,
                    marginBottom: 6,
                    display: "inline-block",
                  }}
                >
                  Phone Number<span style={{ color: "red" }}>*</span>
                </label>
                <Controller
                  name='phoneNumber'
                  control={control}
                  rules={{ required: "Phone Number is required" }}
                  render={({
                    field: { onChange, value },
                    fieldState: { error },
                  }) => (
                    <CustomTextfield
                      labelColor="#171717"
                      type="number"
                      size="large"
                      value={value}
                      prefix={
                        <PhoneOutlined style={{ color: "#999999", paddingRight: 4 }} />
                      }
                      placeholder="Phone Number"
                      onChange={onChange}
                      status={error ? "error" : ""}
                    />
                  )}
                />
              </Col>

              <Col span={12}>
                <label
                  style={{
                    fontWeight: 500,
                    marginBottom: 6,
                    display: "inline-block",
                  }}
                >
                  Email
                </label>
                <Controller
                  name='email'
                  control={control}
                  rules={{ 
                    pattern: {
                      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                      message: "Please enter a valid email address",
                    },
                  }}
                  render={({
                    field: { onChange, value },
                    fieldState: { error },
                  }) => (
                    <CustomTextfield
                      labelColor="#171717"
                      showSearch
                      size="large"
                      value={value}
                      placeholder="Email"
                      onChange={onChange}
                      status={error ? "error" : ""}
                    />
                  )}
                />
              </Col>
            </Row>

            <Row gutter={[16, 16]}>
              <Col span={12}>
                <label
                  style={{
                    fontWeight: 500,
                    marginBottom: 6,
                    display: "inline-block",
                  }}
                >
                  Occupation
                </label>
                <Controller
                  name='occupation'
                  control={control}
                  render={({
                    field: { onChange, value },
                    fieldState: { error },
                  }) => (
                    <CustomTextfield
                      labelColor="#171717"
                      showSearch
                      size="large"
                      value={value}
                      placeholder="Occupation"
                      onChange={onChange}
                      status={error ? "error" : ""}
                    />
                  )}
                />
              </Col>

              <Col span={12}>
                <label
                  style={{
                    fontWeight: 500,
                    marginBottom: 6,
                    display: "inline-block",
                  }}
                >
                  Address
                </label>
                <Controller
                  name='address'
                  control={control}
                  render={({
                    field: { onChange, value },
                    fieldState: { error },
                  }) => (
                    <CustomTextfield
                      labelColor="#171717"
                      showSearch
                      size="large"
                      value={value}
                      placeholder="Address"
                      onChange={onChange}
                      status={error ? "error" : ""}
                    />
                  )}
                />
              </Col>
            </Row>
          </Space>
        </div>

        <div className={styles.formActions}>
          <Space
            style={{
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <Button onClick={onClose}>Cancel</Button>
            <Button
              type="primary"
              htmlType="submit"
              style={{
                background: "rgba(57, 181, 74, 1)",
                borderColor: "rgba(57, 181, 74, 1)",
              }}
            >
              Save
            </Button>
          </Space>
        </div>
      </form>

    </CustomDrawer>
  );
};

export default AddEditParent;